import React from 'react';
import { GlobalState, UI } from '@leverege/ui-redux';
import RouteUtils from '@leverege/api/src/routes/RouteUtils.js';
import User from '@leverege/api/src/routes/authz/User.js';
import { ResourceUsersScreen } from '@leverege/api-ui-user-management';
import { ResourceUser, ResourceUsers } from '@leverege/api-redux';
import OpenApiApi from "../../openApiApi/OpenApiApi.js";
export default ({
  id,
  relationship
}) => ({
  id,
  exact: true,
  path: `/${relationship.urlPath}/access`,
  matches: {
    client: 'ItemScreen',
    path: relationship.path
  },
  render: ({
    match,
    location,
    history,
    ...rest
  }) => {
    const api = new OpenApiApi({
      relationship,
      match
    });
    const comms = api.childComms;
    const rootComms = api.comms;
    const getUsersApi = (dispatch, getState, opts, resourceId) => {
      return {
        users: () => RouteUtils.authzUsers(comms),
        user: userId => new User(comms, userId)
      };
    };
    const props = {
      ...rest,
      match,
      location,
      history,
      selectorProps: {
        // simple : true,
        // roleFilter
        getRoles: () => {
          const roles = GlobalState.get()?.ui?.relay?.roles?.items;
          return {
            projectRoles: roles ?? [],
            imagineRoles: []
          };
        },
        fetchRoles: async opts => {
          const roles = await rootComms.child('v1/role').get();
          GlobalState.dispatch(UI.set('relay/roles', roles));
          // return { items : [] }
        }
      },
      variants: {
        editorPane: 'formBody',
        inputLabel: 'inputTitle',
        inputText: 'default',
        inputCaption: 'caption',
        selectionSubtitle: 'caption'
      },
      projectId: 'relay',
      resourceId: match?.params?.registryId,
      actions: {
        user: userId => new ResourceUser({
          userId,
          resourceId: match?.params?.registryId,
          resourceApi: getUsersApi
        }),
        users: userId => new ResourceUsers({
          resourceId: match?.params?.registryId,
          resourceApi: getUsersApi
        })
      },
      api: {
        project: () => ({
          accounts: () => ({
            list: opts => {
              delete opts.resourceId;
              return rootComms.child('v1/userExists').get(opts);
            }
          }),
          oidcClients: () => ({
            list: () => ({
              items: []
            })
          }),
          apiAccess: () => ({
            list: () => ({
              items: []
            })
          })
        })
      }
    };
    return /*#__PURE__*/React.createElement(ResourceUsersScreen, props);
  }
});